import type { AttendanceRecord, AbsensiStatus, Karyawan } from "../mobile/types";

export interface MockSubmitResult {
  success: boolean;
  message: string;
}
 
export async function mockSubmitAttendance(formData: FormData) {
  const requestOptions = {
    method: "POST",
    body: formData,
    redirect: "follow" as RequestRedirect
  };

  return await fetch( process.env.REACT_APP_API_URL_V2 + "/karyawan/absensi/post", requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => { return { status : 500, error : error.getMessage(), message : "Terdaap error saat Submit Absensi" } });
}

export function resolveStatus(jamMasukIso: string): AbsensiStatus {
  const hour = new Date(jamMasukIso).getHours();
  return hour >= 9 ? "terlambat" : "tepat";
}

export let mockCurrentEmployee: Karyawan = { id: 0, nama: "-", level: "user", jabatan: "-", no_kary: "-", no_hp: "-", user_id: 0, email : "-", username : "-" };

export const fetchKaryawan = async (id_karyawan : string) => {
  let apiUrl = process.env.REACT_APP_API_URL_V2 + "/karyawan/pegawai/" + id_karyawan;
  const requestOptions = {
    method: "GET",
    redirect: "follow" as RequestRedirect
  };

  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) =>  { return { status : 500, message : error.getMessage() } });
}


 
export async function getSeedRecords(id_karyawan : string){
  let apiUrl = process.env.REACT_APP_API_URL_V2 + "/karyawan/absensi/" + id_karyawan;
  const requestOptions = { method: "GET", redirect: "follow" as RequestRedirect };

  let result = await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) =>  { return { status : 500, message : error.getMessage() } });

  if (Array.isArray(result)) {
    result = result.map((el: any) => ({
      ...el,
      jam_keluar: el.jam_keluar ? new Date(el.jam_keluar).toISOString() : null,
      jam_masuk: el.jam_masuk ? new Date(el.jam_masuk).toISOString() : null,
      tanggal: el.tanggal ? new Date(el.tanggal).toISOString() : null,
    }));
  }

  return result;
}